/** 水表公摊组列表 /metering/fee/watermeterSharing */
export default {
  watermeterSharing: {
    phGroupId: '请输入公摊组编号',
    phGroupName: '请输入公摊组名称',
    btnSearch: '查询',
    btnReset: '重置',
    btnExport: '导出',
    listTitle: '水表公摊组列表',
    btnAdd: '新增',
    sortDefault: '默认排序',
    colId: '公摊组编号',
    colName: '公摊组名称',
    colActions: '操作',
    opDetail: '详情',
    opDelete: '删除',
    opDebit: '手动扣款',
    emptyDesc: '暂无数据',
    dialogAddTitle: '新增水表公摊组',
    dialogEditTitle: '修改水表公摊组',
    formName: '公摊组名',
    phFormName: '请输入公摊组名',
    btnCancel: '取 消',
    btnConfirm: '确 定',
    btnSubmitting: '提交中...',
    debitTitle: '水表公摊组扣款',
    debitFormName: '公摊组名',
    debitFormId: '公摊组ID',
    debitFormAmount: '扣款金额',
    debitFormRemark: '备注内容',
    phAmount: '请输入扣款金额',
    phRemark: '请输入备注内容',
    yuanSuffix: '元',
    debitBtnCancel: '取 消',
    debitConfirm: '确认扣款',
    debitSubmitting: '扣款中...',
    msgFetchFail: '获取数据失败',
    msgFetchListFail: '获取水表公摊组数据失败',
    msgNoViewPermission: '无查看权限',
    msgNoAddPermission: '无新增权限',
    msgNoDeletePermission: '无删除权限',
    msgNoDebitPermission: '无手动扣款权限',
    msgExportEmpty: '暂无数据可导出',
    msgExportOk: '成功导出{count}条数据',
    msgExportFail: '导出失败',
    exportSheetName: '水表公摊组',
    exportFilePrefix: '水表公摊组_',
    confirmDeleteTitle: '提示',
    confirmDeleteMsg: '删除公摊组将同时移除公摊组关联的租户和水表，确认删除吗?',
    confirmOk: '确定',
    confirmCancel: '取消',
    msgDeleteOk: '删除成功',
    msgDeleteFail: '删除失败',
    confirmGroupTitle: '提示',
    confirmGroupAdd: '确认新增公摊组?',
    confirmGroupEdit: '确认修改公摊组?',
    msgAddOk: '新增成功',
    msgEditOk: '修改成功',
    msgAddFail: '新增失败',
    msgEditFail: '修改失败',
    confirmDebitTitle: '提示',
    confirmDebitMsg: '确认扣款?',
    msgDebitOk: '扣款成功',
    msgDebitFail: '扣款失败',
    ruleNameRequired: '请输入公摊组名',
    ruleNameLen: '长度在 1 到 50 个字符',
    ruleAmountRequired: '请输入扣款金额',
    ruleAmountInvalid: '请输入有效的金额',
    ruleAmountPositive: '扣款金额必须大于0',
    ruleAmountMax: '扣款金额不能超过999999.99'
  }
}
